import GameOverNotRegistered from "components/GameOverNotRegistered";
//import LetterJumbleContainer from "containers/LetterJumbleContainer";
import WordPairs from "modules/WordPairs/container/WordPairs";
//import WordSearchContainer from "containers/WordSearchContainer";
import SchulteLetters from "modules/SchulteLetters/container/SchulteLetters"
import SchulteNumbers from "modules/SchulteLetters/container/SchulteNumbers"
import SchulteMix from "modules/SchulteLetters/container/SchulteMix"
import Letterjumble from "modules/GridSearch/container/LetterJumble"
import WordSearch from "modules/GridSearch/container/WordSearch"
import NumberSearch from "modules/GridSearch/container/NumberSearch"
import WPMTest from "modules/WPMTest/container/WPMTest"
import ComingSoon from "modules/Pages/container/ComingSoon"
//import WpmTestContainer from "containers/WpmTestContainer";
import Dashboard from "modules/Dashboard/container/Dashboard";
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import "./App.css";
import { strings } from "constants/strings";
import { checkSubscription } from "helpers/subscriptionProvider";
import FAQ from "modules/Pages/container/FAQ"
import mobileFAQ from "modules/Pages/container/mobileFAQ"

const subscriptionIsActive = checkSubscription();//useSubscriptionContext();
function customRedirect(condition,renderedComponent,path) {
  if(condition) {
    return renderedComponent
  } else {
    //return <div>sraca</div>
    return () => {window.location = path}
  }
}
class App extends Component {  
  render() {
    /*
    <Route path={strings.LetterJumble_path}  component={LetterJumbleContainer} />
            <Route path={strings.WordPairs_path}  component={WordPairsContainer} />
            <Route path={strings.WPMTest_path}  component={WpmTestContainer} />
            <Route path={strings.WordSearch_path} component={WordSearchContainer} />
            
            <Route path={strings.Web_Wpmtest_link}  component={WpmTestContainer} />
            <Route
              path={strings.WordPairsInitial_path}
              render={(props) => (
                <WordPairsContainer
                  {
                    ...props
                  }
                  initial = {true}
                  gameOverComponent={(passed) => (
                    <GameOverNotRegistered {...passed} />
                  )}
                />
              )}
            />
            */
    return (
      <Router>
        <Switch>
          <Route path='/react'>
            {customRedirect(false,'','/')}
          </Route>
          <Route path={strings.Web_schulteletters_link}>
            {customRedirect(subscriptionIsActive,<SchulteLetters />,strings.Web_prices_link)}
          </Route>
          <Route path={strings.Web_schultenumbers_link}>
            {customRedirect(subscriptionIsActive,<SchulteNumbers />,strings.Web_prices_link)}
          </Route>
          <Route path={strings.Web_schultemix_link}>            
            {customRedirect(subscriptionIsActive,<SchulteMix />,strings.Web_prices_link)}
          </Route>
          <Route path={strings.Web_LetterJumble_link} component={Letterjumble}/>
          <Route path={strings.Web_Wordpairs_link} component={WordPairs}/>
          <Route path={strings.Web_Wordsearch_link}>
            {customRedirect(subscriptionIsActive,<WordSearch />,strings.Web_prices_link)}
          </Route>
          <Route path={strings.Web_Wpmtest_link}>
            {customRedirect(subscriptionIsActive,<WPMTest />,strings.Web_prices_link)}
          </Route>
          <Route path={strings.Web_dashboard_link} component={Dashboard}/>
          <Route path={strings.Web_comingsoon_link} component={ComingSoon} />
          <Route path={strings.Web_faq_link} component={FAQ}/>
          <Route path={strings.Web_faq_mobile_link} component={mobileFAQ}/>
          <Route
            path={strings.Web_wordpairstrial_link}
            render={(props) => (
              <WordPairs
                {
                ...props
                }
                initial={true}
                gameOverComponent={(passed) => (
                  <GameOverNotRegistered {...passed} />
                )}
              />
            )}
          />
        </Switch>
      </Router>
    );
  }
}
//Web_imprint_link
//Web_pagenotfound_link
//Web_thankyou_link
//Web_Privacy_link

// Wrap the component to inject dispatch and state into it
export default App;
